
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const UserStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  DISABLED: 'DISABLED'
} as const

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus]


export const UserRole = {
  READ_ONLY: 'READ_ONLY',
  ASSISTANT: 'ASSISTANT',
  RESTRICTED: 'RESTRICTED',
  ESTIMATOR: 'ESTIMATOR',
  SITE_ADMIN: 'SITE_ADMIN',
  SUPERADMIN: 'SUPERADMIN'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const ERPDB = {
  VISUAL: 'VISUAL',
  VISUALSPR: 'VISUALSPR',
  VISUALFAS: 'VISUALFAS',
  EPICOR: 'EPICOR'
} as const

export type ERPDB = (typeof ERPDB)[keyof typeof ERPDB]


export const QuoteBuilderVersion = {
  V1: 'V1',
  V2: 'V2'
} as const

export type QuoteBuilderVersion = (typeof QuoteBuilderVersion)[keyof typeof QuoteBuilderVersion]


export const ConfiguratorSnapshotVersion = {
  V1: 'V1',
  V2: 'V2'
} as const

export type ConfiguratorSnapshotVersion = (typeof ConfiguratorSnapshotVersion)[keyof typeof ConfiguratorSnapshotVersion]


export const WonLossStatus = {
  COMPLETED: 'COMPLETED',
  CONVERTED: 'CONVERTED',
  LOSS_CAPABILITIES: 'LOSS_CAPABILITIES',
  LOSS_CAPABILITIES_NO_QUOTE: 'LOSS_CAPABILITIES_NO_QUOTE',
  LOSS_CUSTOMER_LOST_BID: 'LOSS_CUSTOMER_LOST_BID',
  LOSS_EXCEPTIONS_NOT_ACCEPTED: 'LOSS_EXCEPTIONS_NOT_ACCEPTED',
  LOSS_LACKING_CERTIFICATION: 'LOSS_LACKING_CERTIFICATION',
  LOSS_LEAD_TIME: 'LOSS_LEAD_TIME',
  LOSS_PRICE: 'LOSS_PRICE',
  LOSS_PROJECT_CANCELLED: 'LOSS_PROJECT_CANCELLED',
  LOSS_QUOTE_NOT_FAST_ENOUGH: 'LOSS_QUOTE_NOT_FAST_ENOUGH',
  LOSS_QUOTING_FOR_MULTIPLE_CUSTOMERS: 'LOSS_QUOTING_FOR_MULTIPLE_CUSTOMERS',
  LOSS_QUOTING_FOR_MULTIPLE_REVS_PART_ITERATIONS: 'LOSS_QUOTING_FOR_MULTIPLE_REVS_PART_ITERATIONS',
  LOSS_ROUTINE_COMPETITIVE_CHECK: 'LOSS_ROUTINE_COMPETITIVE_CHECK',
  LOSS_TERMS_OF_SALE: 'LOSS_TERMS_OF_SALE',
  PAUSED: 'PAUSED',
  PENDING_BUYOUT_PRICE: 'PENDING_BUYOUT_PRICE',
  PENDING_CUSTOMER_RESPONSE: 'PENDING_CUSTOMER_RESPONSE',
  PENDING_MANUFACTURING: 'PENDING_MANUFACTURING',
  PENDING_OUTSIDE_PROCESS: 'PENDING_OUTSIDE_PROCESS',
  PENDING_REVISED_PO_CONTRACT_REVIEW: 'PENDING_REVISED_PO_CONTRACT_REVIEW',
  PENDING_REVISED_PO_PRICE: 'PENDING_REVISED_PO_PRICE',
  QUOTED: 'QUOTED',
  RFQ_RECEIVED: 'RFQ_RECEIVED',
  WIN_CAPABILITIES: 'WIN_CAPABILITIES',
  WIN_LEAD_TIME: 'WIN_LEAD_TIME',
  WIN_PRICE: 'WIN_PRICE'
} as const

export type WonLossStatus = (typeof WonLossStatus)[keyof typeof WonLossStatus]


export const PartSpecTable = {
  PART_BINARY: 'PART_BINARY',
  PART_CO_BINARY: 'PART_CO_BINARY'
} as const

export type PartSpecTable = (typeof PartSpecTable)[keyof typeof PartSpecTable]


export const LeadTimeFormat = {
  BOTH: 'BOTH',
  NUMBER: 'NUMBER',
  TEXT: 'TEXT'
} as const

export type LeadTimeFormat = (typeof LeadTimeFormat)[keyof typeof LeadTimeFormat]


export const FeatureVisibility = {
  NONE: 'NONE',
  SUPER_ADMIN: 'SUPER_ADMIN',
  ALL: 'ALL'
} as const

export type FeatureVisibility = (typeof FeatureVisibility)[keyof typeof FeatureVisibility]


export const QuotePdfType = {
  ADF: 'ADF',
  AMF: 'AMF',
  ANA: 'ANA',
  ASM: 'ASM',
  BTL: 'BTL',
  CAP: 'CAP',
  CSC: 'CSC',
  CSC_CUSTOM: 'CSC_CUSTOM',
  DEFAULT: 'DEFAULT',
  GRE: 'GRE',
  HPC: 'HPC',
  MMC: 'MMC',
  MWS: 'MWS',
  MWS_HYPERCO: 'MWS_HYPERCO',
  PON: 'PON',
  RAF: 'RAF',
  ROC: 'ROC',
  SPM: 'SPM',
  USA: 'USA',
  WWP: 'WWP'
} as const

export type QuotePdfType = (typeof QuotePdfType)[keyof typeof QuotePdfType]


export const EmailConfigType = {
  ANA: 'ANA',
  CSC: 'CSC',
  CSC_CUSTOM: 'CSC_CUSTOM',
  DEFAULT: 'DEFAULT',
  DO_NOT_SEND: 'DO_NOT_SEND',
  RAF: 'RAF',
  USA: 'USA'
} as const

export type EmailConfigType = (typeof EmailConfigType)[keyof typeof EmailConfigType]


export const QuoteEmailTemplate = {
  CAP: 'CAP',
  CSC_CUSTOM: 'CSC_CUSTOM',
  DEFAULT: 'DEFAULT'
} as const

export type QuoteEmailTemplate = (typeof QuoteEmailTemplate)[keyof typeof QuoteEmailTemplate]


export const LeadTimeConfigType = {
  PLANNING_LEADTIME: 'PLANNING_LEADTIME',
  CONSTANT_VALUE: 'CONSTANT_VALUE',
  RAF_FIXED_MARKET: 'RAF_FIXED_MARKET',
  QUANTITY_AWARE: 'QUANTITY_AWARE'
} as const

export type LeadTimeConfigType = (typeof LeadTimeConfigType)[keyof typeof LeadTimeConfigType]


export const SellingUnitOfMeasure = {
  EA: 'EA',
  M: 'M'
} as const

export type SellingUnitOfMeasure = (typeof SellingUnitOfMeasure)[keyof typeof SellingUnitOfMeasure]


export const PartStatus = {
  A: 'A',
  I: 'I',
  O: 'O'
} as const

export type PartStatus = (typeof PartStatus)[keyof typeof PartStatus]


export const QuoteStatus = {
  NEW: 'NEW',
  INPROGRESS: 'INPROGRESS',
  SENT: 'SENT',
  WON: 'WON',
  LOSS: 'LOSS',
  DELETED: 'DELETED',
  CANCELLED: 'CANCELLED',
  INHOUSE: 'INHOUSE',
  READY: 'READY',
  TEST: 'TEST'
} as const

export type QuoteStatus = (typeof QuoteStatus)[keyof typeof QuoteStatus]


export const QuoteLineStatus = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED'
} as const

export type QuoteLineStatus = (typeof QuoteLineStatus)[keyof typeof QuoteLineStatus]


export const OrderStatus = {
  C: 'C',
  X: 'X',
  R: 'R',
  H: 'H',
  F: 'F'
} as const

export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus]


export const OrderLineStatus = {
  A: 'A',
  C: 'C'
} as const

export type OrderLineStatus = (typeof OrderLineStatus)[keyof typeof OrderLineStatus]


export const DocumentType = {
  MASTER_QUOTE: 'MASTER_QUOTE',
  QUOTE_DOCUMENT: 'QUOTE_DOCUMENT',
  OPERATION_DOCUMENT: 'OPERATION_DOCUMENT',
  IMPORT_SPREADSHEET: 'IMPORT_SPREADSHEET'
} as const

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType]


export const RunRateType = {
  PCS_PER_HR: 'PCS_PER_HR',
  HRS_PER_PC: 'HRS_PER_PC',
  MIN_PER_PC: 'MIN_PER_PC',
  DAYS_PER_PC: 'DAYS_PER_PC',
  HRS_PER_LOAD: 'HRS_PER_LOAD',
  DAYS_PER_LOAD: 'DAYS_PER_LOAD',
  PCS_PER_MIN: 'PCS_PER_MIN',
  PCS_PER_DAY: 'PCS_PER_DAY',
  LOADS_PER_HR: 'LOADS_PER_HR',
  LOADS_PER_DAY: 'LOADS_PER_DAY'
} as const

export type RunRateType = (typeof RunRateType)[keyof typeof RunRateType]


export const ScrapYieldType = {
  SCRAP: 'SCRAP',
  YIELD: 'YIELD'
} as const

export type ScrapYieldType = (typeof ScrapYieldType)[keyof typeof ScrapYieldType]


export const PriceStrategy = {
  Alpha: 'Alpha',
  CAPPriceSegmentation: 'CAPPriceSegmentation',
  FixedCustomer: 'FixedCustomer',
  FixedDefault: 'FixedDefault',
  FixedDiscount: 'FixedDiscount',
  FixedMarket: 'FixedMarket',
  NewPart: 'NewPart',
  NewPartUserCost: 'NewPartUserCost',
  NewPartUserPrice: 'NewPartUserPrice',
  PriceSegmentation: 'PriceSegmentation',
  PriceSegmentationWithTargetGrossMargin: 'PriceSegmentationWithTargetGrossMargin',
  RAFFixedMarket: 'RAFFixedMarket',
  RAFTargetGrossMargin: 'RAFTargetGrossMargin',
  ServiceCharge: 'ServiceCharge',
  TargetContributionMargin: 'TargetContributionMargin',
  TargetGrossMargin: 'TargetGrossMargin',
  UserImport: 'UserImport',
  UserPrice: 'UserPrice'
} as const

export type PriceStrategy = (typeof PriceStrategy)[keyof typeof PriceStrategy]


export const SnapQuoteStatus = {
  INPROGRESS: 'INPROGRESS',
  SENT: 'SENT',
  DELETED: 'DELETED'
} as const

export type SnapQuoteStatus = (typeof SnapQuoteStatus)[keyof typeof SnapQuoteStatus]


export const SnapQuoteAssignmentSource = {
  SYSTEM: 'SYSTEM',
  USER: 'USER'
} as const

export type SnapQuoteAssignmentSource = (typeof SnapQuoteAssignmentSource)[keyof typeof SnapQuoteAssignmentSource]


export const InitialMarginSource = {
  lastWin: 'lastWin',
  targetContributionMargin: 'targetContributionMargin',
  targetGrossMargin: 'targetGrossMargin',
  calculatedFromLastWinUnitPrice: 'calculatedFromLastWinUnitPrice'
} as const

export type InitialMarginSource = (typeof InitialMarginSource)[keyof typeof InitialMarginSource]


export const SnapSuggestionStatus = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  EXCLUDED: 'EXCLUDED',
  UNKNOWN: 'UNKNOWN'
} as const

export type SnapSuggestionStatus = (typeof SnapSuggestionStatus)[keyof typeof SnapSuggestionStatus]


export const ProductComplexityRanking = {
  Simple: 'Simple',
  Moderate: 'Moderate',
  Complex: 'Complex'
} as const

export type ProductComplexityRanking = (typeof ProductComplexityRanking)[keyof typeof ProductComplexityRanking]


export const SnapUnsupportedCalculation = {
  REQUIREMENT_USAGE_UOM_HAS_MULTIPLIER: 'REQUIREMENT_USAGE_UOM_HAS_MULTIPLIER',
  OPERATION_RUN_TYPE_UNKNOWN: 'OPERATION_RUN_TYPE_UNKNOWN',
  REQUIREMENT_HAS_SUBASSEMBLY: 'REQUIREMENT_HAS_SUBASSEMBLY',
  PART_HAS_SUB_OPERATIONS: 'PART_HAS_SUB_OPERATIONS'
} as const

export type SnapUnsupportedCalculation = (typeof SnapUnsupportedCalculation)[keyof typeof SnapUnsupportedCalculation]


export const QtyPerType = {
  START: 'START',
  END: 'END'
} as const

export type QtyPerType = (typeof QtyPerType)[keyof typeof QtyPerType]


export const UnitsOfMeasure = {
  BAR: 'BAR',
  BAR10: 'BAR10',
  BAR12: 'BAR12',
  BAR16: 'BAR16',
  BAR6: 'BAR6',
  BX: 'BX',
  BX100: 'BX100',
  BX1000: 'BX1000',
  BX25: 'BX25',
  BX50: 'BX50',
  C: 'C',
  CLB: 'CLB',
  CS: 'CS',
  CTN: 'CTN',
  DAB: 'DAB',
  DZ: 'DZ',
  EA: 'EA',
  FT: 'FT',
  GAL: 'GAL',
  HR: 'HR',
  IN: 'IN',
  K: 'K',
  KG: 'KG',
  LB: 'LB',
  LBC: 'LBC',
  LBM: 'LBM',
  LBS: 'LBS',
  LOT: 'LOT',
  LY15: 'LY15',
  LY40: 'LY40',
  LY42: 'LY42',
  LY43: 'LY43',
  LY50: 'LY50',
  M: 'M',
  MLB: 'MLB',
  MM: 'MM',
  OZ: 'OZ',
  PKG: 'PKG',
  PR: 'PR',
  SET: 'SET',
  SQFT: 'SQFT',
  SQIN: 'SQIN',
  TOZ: 'TOZ',
  TUBE8OZ: 'TUBE8OZ',
  UNKNOWN: 'UNKNOWN'
} as const

export type UnitsOfMeasure = (typeof UnitsOfMeasure)[keyof typeof UnitsOfMeasure]


export const PriceSegmentType = {
  CustomerPotential: 'CustomerPotential',
  CustomerPortals: 'CustomerPortals',
  CustomerTerms: 'CustomerTerms',
  ProductOperationsCount: 'ProductOperationsCount',
  ProductComplexity: 'ProductComplexity',
  MarketIndustry: 'MarketIndustry',
  LastTransactionAge: 'LastTransactionAge',
  LastGrossMargin: 'LastGrossMargin'
} as const

export type PriceSegmentType = (typeof PriceSegmentType)[keyof typeof PriceSegmentType]


export const AutoConfiguratorImplementation = {
  ALPHA: 'ALPHA'
} as const

export type AutoConfiguratorImplementation = (typeof AutoConfiguratorImplementation)[keyof typeof AutoConfiguratorImplementation]


export const AlphaDimensionUnit = {
  IMPERIAL: 'IMPERIAL',
  METRIC: 'METRIC'
} as const

export type AlphaDimensionUnit = (typeof AlphaDimensionUnit)[keyof typeof AlphaDimensionUnit]


export const AlphaQuoteLineStatus = {
  ACTIVE: 'ACTIVE',
  PENDING_DELETE: 'PENDING_DELETE'
} as const

export type AlphaQuoteLineStatus = (typeof AlphaQuoteLineStatus)[keyof typeof AlphaQuoteLineStatus]


export const AlphaQuoteEvaluationStatus = {
  INCOMPLETE: 'INCOMPLETE',
  CALCULATED: 'CALCULATED',
  CONSULT_ENGINEERING: 'CONSULT_ENGINEERING',
  CALCULATION_ERROR: 'CALCULATION_ERROR'
} as const

export type AlphaQuoteEvaluationStatus = (typeof AlphaQuoteEvaluationStatus)[keyof typeof AlphaQuoteEvaluationStatus]


export const AlphaQuoteSyncStatus = {
  UNSYNCED: 'UNSYNCED',
  SYNCED: 'SYNCED',
  STALE: 'STALE'
} as const

export type AlphaQuoteSyncStatus = (typeof AlphaQuoteSyncStatus)[keyof typeof AlphaQuoteSyncStatus]


export const AlphaSite = {
  ADF: 'ADF',
  ROC: 'ROC'
} as const

export type AlphaSite = (typeof AlphaSite)[keyof typeof AlphaSite]


export const SalesTaxGroupId = {
  NON_TAXABLE: 'NON_TAXABLE'
} as const

export type SalesTaxGroupId = (typeof SalesTaxGroupId)[keyof typeof SalesTaxGroupId]
